import React, { FC } from 'react';

import Seo from '../Seo';
import Error from '../Error';
import Loading from '../Loading';

import useServerContext from '../../hooks/useServerContext';

interface Props {
  seoProps?: any;
  loading: any;
  error: any;
}

const DataLoadingAndErrorUI: FC<Props> = ({ error, loading, seoProps }) => {
  const { serverContext } = useServerContext();

  let content;
  if (loading) {
    content = <Loading />;
  }

  if (error) {
    if (serverContext?.res) {
      const errorCode = error.graphQLErrors[0].extensions?.response.status || 500;
      serverContext.res.statusCode = errorCode;
    }
    content = <Error error={error} />;
  }

  return content ? (
    <>
      {seoProps && <Seo {...seoProps} />}
      {content}
    </>
  ) : null;
};

export default React.memo(DataLoadingAndErrorUI);
